const userTable = {
  columns: {
    id: "Auðkenni",
    name: "Nafn",
    email: "Netfang",
    institution: "Stofnun",
    status: "Staða",
    role: "Hlutverk",
    projects: "Verkefni",
    created: "Búið til",
    actions: "Aðgerðir",
  },
  status: {
    active: "Virkur",
    inactive: "Óvirkur",
    pendingActivation: "Bíður virkjunar",
    pendingActivationTooltip:
      "⚠️ Tvíþátta auðkenning er í endurstillingu - notandi verður að setja hana upp aftur við næstu innskráningu",
  },
  roles: {
    manager: "Stjórnandi",
    dataUploader: "Gagnahleðari",
    pi: "PI",
    researcher: "Rannsakandi",
    owner: "Eigandi",
  },
  actionsMenu: {
    userActionsTitle: "Aðgerðir notanda",
    removeFromProjectDirect: "➖ Fjarlægja úr verkefni",
    removeFromProjectDisabledTooltip:
      "Ábyrgðarmenn (PI) geta ekki fjarlægt aðra ábyrgðarmenn. Hafðu samband við stjórnanda stofnunar.",
    disable2fa: "🔓 Slökkva á tvíþátta auðkenningu",
    addToProjectToggle: "➕ Bæta við verkefni",
    removeFromProjectToggle: "➖ Fjarlægja úr verkefni",
    promoteToPI: "⬆ Gera að ábyrgðarmanni (PI)",
    revokePI: "⬇ Afturkalla PI-hlutverk",
  },
  invited: {
    badge: "Boðið",
    copyLink: "Afrita hlekk",
    revoke: "Afturkalla",
  },
  dialog: {
    title: "Staðfesta aðgerð",
    disable2faBody:
      "Ertu viss um að þú viljir slökkva á tvíþátta auðkenningu fyrir þennan notanda? Viðkomandi þarf að setja hana upp aftur við næstu innskráningu.",
    removeBodyNamed:
      'Ertu viss um að þú viljir fjarlægja þennan notanda úr "{{title}}"?',
    removeBodyGeneric:
      "Ertu viss um að þú viljir fjarlægja þennan notanda úr verkefninu?",
    addBodyNamed: 'Bæta þessum notanda við sem rannsakanda í "{{title}}"?',
    addBodyGeneric: "Bæta þessum notanda við sem rannsakanda í verkefnið?",
    promotePIBody:
      "Gera þennan notanda að ábyrgðarmanni (PI)? Viðkomandi mun geta stofnað verkefni og stýrt eigin rannsóknarverkefnum.",
    revokePIBody:
      "Afturkalla PI-stöðu þessa notanda? Viðkomandi verður lækkaður/lækkuð í rannsakanda og fjarlægður/fjarlægð sem ábyrgðarmaður úr öllum virkum verkefnum sem viðkomandi stýrir núna.",
    processing: "Afgreiði...",
  },
};

export default userTable;
